import { Tooltip, Typography } from "@mui/material";
import { EpisodicBadge } from "components/EpisodicBadge";
import { LineItemFragment } from "generated-graphql/graphql";
import {
  episodicCellTooltip,
  formatPounds,
} from "routes/Customer/Waste/EpisodicEvents/episodicDisplay";

type LineEpisodicExemptions = LineItemFragment["episodicExemptions"];

const excludedPounds = (exemptions: LineEpisodicExemptions) =>
  exemptions.reduce((sum, exemption) => sum + exemption.pounds, 0);

export function lineEpisodicBadgeTooltip(exemptions: LineEpisodicExemptions): string {
  return episodicCellTooltip(
    exemptions.map((exemption) => exemption.episodicEvent.reason),
    excludedPounds(exemptions)
  );
}

export function LineEpisodicBadge({ exemptions }: { exemptions: LineEpisodicExemptions }) {
  if (exemptions.length === 0) {
    return null;
  }
  return <EpisodicBadge density="compact" tooltip={lineEpisodicBadgeTooltip(exemptions)} />;
}

/** The grid column form: the excluded pounds, 0 lb included, with the event named on hover. */
export function LineEpisodicCell({ exemptions }: { exemptions: LineEpisodicExemptions }) {
  if (exemptions.length === 0) {
    return null;
  }
  const pounds = excludedPounds(exemptions);
  return (
    <Tooltip title={lineEpisodicBadgeTooltip(exemptions)}>
      <Typography variant="body2" component="span">
        {formatPounds(pounds)}
      </Typography>
    </Tooltip>
  );
}
